import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-815ef17e")

_pushScopeId("data-v-815ef17e")
const _hoisted_1 = { class: "InvoiceServices" }
const _hoisted_2 = { class: "InvoiceServices__title" }
const _hoisted_3 = {
  key: 0,
  class: "InvoiceServices__body"
}
const _hoisted_4 = {
  key: 1,
  class: "InvoiceServices__body"
}
const _hoisted_5 = {
  key: 0,
  class: "body__text"
}
const _hoisted_6 = {
  key: 1,
  class: "body__text"
}
const _hoisted_7 = {
  key: 2,
  class: "body__text"
}
const _hoisted_8 = {
  key: 3,
  class: "body__text"
}
const _hoisted_9 = {
  key: 4,
  class: "body__text"
}
const _hoisted_10 = {
  key: 5,
  class: "body__text"
}
const _hoisted_11 = {
  key: 6,
  class: "body__text"
}
const _hoisted_12 = {
  key: 7,
  class: "body__text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.newAdditionalServices.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newAdditionalServices, (new_service, i) => {
            return (_openBlock(), _createBlock("span", {
              key: `NewAdditionalService-${i}`,
              class: "body__text"
            }, _toDisplayString(new_service.type_name), 1))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          (_ctx.additionalServices.car)
            ? (_openBlock(), _createBlock("span", _hoisted_5, "Авто"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.soft_package)
            ? (_openBlock(), _createBlock("span", _hoisted_6, "Мягкая упаковка"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.manipulator)
            ? (_openBlock(), _createBlock("span", _hoisted_7, "Манипулятор"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.crane)
            ? (_openBlock(), _createBlock("span", _hoisted_8, "Кран"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.hydraulic_trolley)
            ? (_openBlock(), _createBlock("span", _hoisted_9, "Рохля"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.grid)
            ? (_openBlock(), _createBlock("span", _hoisted_10, "Обрешетка"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.loader)
            ? (_openBlock(), _createBlock("span", _hoisted_11, "Грузчики"))
            : _createCommentVNode("", true),
          (_ctx.additionalServices.pallet)
            ? (_openBlock(), _createBlock("span", _hoisted_12, "Паллета"))
            : _createCommentVNode("", true)
        ]))
  ]))
})